export default __webpack_public_path__ + "static/media/iconGridCuatro.01024c55.png";